import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { format } from 'date-fns';
import API_BASE_URL from '../../Config';

const LibroMayor = () => {
    const [cuentas, setCuentas] = useState([]);
    const [cuentaId, setCuentaId] = useState('');
    const [mayorData, setMayorData] = useState(null);
    const [loading, setLoading] = useState(false);
    
    // Default last 30 days
    const [fechaInicio, setFechaInicio] = useState(format(new Date(new Date().setDate(new Date().getDate() - 30)), 'yyyy-MM-dd'));
    const [fechaFin, setFechaFin] = useState(format(new Date(), 'yyyy-MM-dd'));

    useEffect(() => {
        const fetchCuentas = async () => {
            try {
                const token = localStorage.getItem('token');
                const res = await axios.get(`${API_BASE_URL}/plan-cuentas`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setCuentas(res.data.filter(c => c.esImputable));
            } catch (err) {
                console.error('Error fetching cuentas', err);
            }
        };
        fetchCuentas();
    }, []);

    const fetchMayor = async () => {
        if (!cuentaId) return;
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const res = await axios.get(`${API_BASE_URL}/contabilidad/mayor/${cuentaId}?inicio=${fechaInicio}&fin=${fechaFin}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setMayorData(res.data);
        } catch (error) {
            console.error("Error cargando el libro mayor", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="card shadow-sm border-0">
            <div className="card-header bg-white border-bottom-0 pt-4">
                <h3 className="mb-0 text-gray-800 font-weight-bold">Libro Mayor por Cuenta</h3>
                <div className="row mt-4 bg-light p-3 rounded-lg border">
                    <div className="col-md-4">
                        <label className="small font-weight-bold text-muted">CUENTA CONTABLE</label>
                        <select className="form-control form-control-sm shadow-sm" value={cuentaId} onChange={e => setCuentaId(e.target.value)}>
                            <option value="">Seleccione cuenta...</option>
                            {cuentas.map(c => (
                                <option key={c.id} value={c.id}>{c.codigoIncoop} - {c.nombreCuenta}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-3">
                        <label className="small font-weight-bold text-muted">FECHA DESDE</label>
                        <input type="date" value={fechaInicio} onChange={e => setFechaInicio(e.target.value)} className="form-control form-control-sm shadow-sm" />
                    </div>
                    <div className="col-md-3">
                        <label className="small font-weight-bold text-muted">FECHA HASTA</label>
                        <input type="date" value={fechaFin} onChange={e => setFechaFin(e.target.value)} className="form-control form-control-sm shadow-sm" />
                    </div>
                    <div className="col-md-2 d-flex align-items-end">
                        <button className="btn btn-primary btn-sm w-100 shadow-sm" onClick={fetchMayor} disabled={!cuentaId || loading}>
                            <i className="fas fa-search mr-2"></i> Consultar
                        </button>
                    </div>
                </div>
            </div>
            
            {mayorData && (
                <div className="card-body p-0 mt-3">
                    <div className="mx-4 mb-3 p-3 border rounded shadow-sm bg-white d-flex justify-content-between align-items-center" style={{ borderLeft: '4px solid #4e73df !important' }}>
                        <div>
                            <h5 className="mb-1 text-primary font-weight-bold">{mayorData.codigoCuenta} - {mayorData.nombreCuenta}</h5>
                            <span className="text-muted small">Extracto de movimientos contables</span>
                        </div>
                        <div className="text-right d-flex gap-4">
                            <div className="px-3 border-right">
                                <label className="small text-muted d-block mb-0">Saldo Inicial</label>
                                <span className="h6 mb-0 font-weight-bold">{new Intl.NumberFormat('es-PY').format(mayorData.saldoInicial)}</span>
                            </div>
                            <div className="px-3">
                                <label className="small text-muted d-block mb-0">Saldo Final</label>
                                <span className="h5 mb-0 font-weight-bold text-success">{new Intl.NumberFormat('es-PY').format(mayorData.saldoFinal)}</span>
                            </div>
                        </div>
                    </div>

                    <div className="table-responsive mdi-scrollbar" style={{ maxHeight: '60vh' }}>
                        <table className="table table-sm table-bordered table-hover mb-0" style={{ fontSize: '0.85rem' }}>
                            <thead className="thead-light sticky-top shadow-sm">
                                <tr>
                                    <th className="py-2 text-center">FECHA</th>
                                    <th className="py-2 text-center">ASIENTO</th>
                                    <th className="py-2 px-3">GLOSA / CONCEPTO</th>
                                    <th className="py-2 px-3 text-right">DEBE</th>
                                    <th className="py-2 px-3 text-right">HABER</th>
                                    <th className="py-2 px-3 text-right">SALDO ACUM.</th>
                                </tr>
                            </thead>
                            <tbody>
                                {mayorData.movimientos.length === 0 ? (
                                    <tr><td colSpan="6" className="text-center py-5 text-muted">No se registraron movimientos en el periodo seleccionado.</td></tr>
                                ) : (
                                    mayorData.movimientos.map((mov, idx) => (
                                        <tr key={idx}>
                                            <td className="text-center text-muted py-2">{mov.fecha}</td>
                                            <td className="text-center py-2 font-weight-bold text-primary">{mov.numeroAsiento}</td>
                                            <td className="py-2 px-3">{mov.glosa}</td>
                                            <td className="text-right py-2 px-3 text-blue-800 font-mono">{mov.debe > 0 ? new Intl.NumberFormat('es-PY').format(mov.debe) : ''}</td>
                                            <td className="text-right py-2 px-3 text-green-800 font-mono">{mov.haber > 0 ? new Intl.NumberFormat('es-PY').format(mov.haber) : ''}</td>
                                            <td className="text-right py-2 px-3 font-weight-bold font-mono">{new Intl.NumberFormat('es-PY').format(mov.saldoAcumulado)}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                            <tfoot className="bg-light shadow-sm">
                                <tr className="font-weight-bold">
                                    <td colSpan="3" className="text-right py-2 px-3 text-muted">TOTALES DEL PERIODO:</td>
                                    <td className="text-right py-2 px-3 text-blue-900 h6 mb-0">{new Intl.NumberFormat('es-PY').format(mayorData.totalDebitos)}</td>
                                    <td className="text-right py-2 px-3 text-green-900 h6 mb-0">{new Intl.NumberFormat('es-PY').format(mayorData.totalCreditos)}</td>
                                    <td className="bg-gray-100"></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            )}
        </div>
    );
};

export default LibroMayor;
